var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"page-container"},[_c('div',{staticClass:"page-container-header"},[_vm._t("header",function(){return [(_vm.header)?_c('span',[_vm._v(_vm._s(_vm.header))]):_vm._e()]})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }